import { CallToAction } from '../components/CallToAction';

export const NotFound = () => (
  <CallToAction
    eyebrow="404"
    title="Seite nicht gefunden"
    description="Die angeforderte Seite existiert nicht mehr oder wurde verschoben. Nutzen Sie die Navigation oder kehren Sie zur Startseite zurück."
    ctaLabel="Zur Startseite"
    ctaTo="/"
    titleAs="h1"
  />
);
